import { render, staticRenderFns } from "./GroupLevelAttributeCoordinatesField.vue?vue&type=template&id=2d4b4c30&"
import script from "./GroupLevelAttributeCoordinatesField.vue?vue&type=script&lang=ts&"
export * from "./GroupLevelAttributeCoordinatesField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports